import { networkBg, dashboardAuth, PrecisionLogoMain, logoWithText } from "assets";
import { Link } from "react-router-dom";
import { Routes } from "router";

const AuthLayout = ({ children }) => {
  return (
    <>
      <main className="grid lg:grid-cols-[1fr_1.175fr] min-h-[100dvh] h-full bg-[#E8F3FF]">
        <div className="lg:flex flex-col justify-between hidden relative bg-[#231F98] p-11">
          <img src={networkBg} alt="networking background" className="object-cover h-full absolute inset-0 opacity-[0.04] pointer-events-none" />
          <Link to={Routes.home} className="w-fit">
            <PrecisionLogoMain className='w-[250px] flex-shrink-0' />
          </Link>
          <img src={dashboardAuth} alt="dashboard background" className="w-full mt-16 mx-auto h-auto object-contain" />

          <div>
            <h3 className="text-white text-3xl font-semibold">Evidence-based hiring starts here!</h3>
            <p className="text-white text-[17px] mt-6 w-full pr-12">Precision helps you assess real capability, predict performance, and place the right people in the right roles.</p>
          </div>

        </div>
        <div className="h-full flex flex-col items-center lg:justify-normal justify-center lg:pt-[13.5%] pt-0 lg:bg-[#E8F3FF] bg-white relative">
          <div className="xl:w-[53%] lg:w-[80%] w-full lg:h-auto h-full">
            <Link to={Routes.home} className="lg:flex hidden">
              <img
                className='xl:w-[215px] lg:w-[180px] w-[140px] h-auto ml-1 lg:mx-auto'
                src={logoWithText}
                alt="precision logo"
              />
            </Link>
            <div className="">
              {children}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export { AuthLayout };

const AuthLayout2 = ({ children }) => {
  return (
    <>
      <main className="grid lg:grid-cols-[1fr_1.175fr] min-h-[100dvh] h-full bg-[#E8F3FF]">
        <div className="lg:flex flex-col justify-between hidden relative bg-[#231F98] p-11">
          <img src={networkBg} alt="networking background" className="object-cover h-full absolute inset-0 opacity-[0.04] pointer-events-none" />
          <Link to={Routes.home} className="w-fit">
            <PrecisionLogoMain className='w-[250px] flex-shrink-0' />
          </Link>
          <img src={dashboardAuth} alt="dashboard background" className="w-full mt-16 mx-auto h-auto object-contain" />

          <div>
          <h3 className="text-white text-3xl font-semibold mt-8">Evidence-based hiring starts here!</h3>
          <p className="text-white text-[17px] mt-6 w-full pr-12">Precision helps you assess real capability, predict performance, and place the right people in the right roles.</p>
          </div>
        </div>
        <div className="h-full flex flex-col items-center lg:justify-normal justify-center lg:pt-[13.5%] pt-0 lg:bg-[#E8F3FF] bg-white relative">
          <div className="xl:w-[53%] lg:w-[80%] w-full lg:h-auto h-full">
            <Link to={Routes.home} className="lg:flex hidden">
              <img
                className='xl:w-[215px] lg:w-[180px] w-[140px] h-auto ml-1 lg:mx-auto'
                src={logoWithText}
                alt="precision logo"
              />
            </Link>
            <div className="">
              {children}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export { AuthLayout2 };
